<template>
  <div class="PerformanceVideo">
    <!-- <div class="statusBar"></div> -->
    <div class="open_app video_app d-f jc-sb ai-c">
      <img src="../../assets/images/detail/logo.png" alt="" />
      <span class="content_app">打开文化广东APP，查看详情内容</span>
      <div class="open_btn" @click="openApp">立即打开</div>
    </div>
    <div class="PerformanceContent">
      <div class="video">
        <!-- <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" /> -->
        <Video id="myVideo" ref="videoPlayer" class="video-js vjs-big-play-centered" :poster="detailInfo.picUrl"></Video>
      </div>
      <div class="introduction">
        <div class="d-f jc-sb ai-c">
          <span class="title">{{ detailInfo.name }}</span>
          <div class="d-f ai-c view_total">
            <img src="@/assets/images/detail/culturalCollection/view.png" alt="" class="icon" /> <span>{{ detailInfo.pageViewNum }} </span>
          </div>
        </div>
        <div class="common_msg date d-f ai-c">
          <img src="@/assets/images/detail/performance/date.png" alt="" class="icon" />
          <span>发布时间：{{ detailInfo.showedTime }} </span>
        </div>
        <div class="common_msg d-f ai-c">
          <img src="@/assets/images/detail/culturalCollection/company_grey.png" alt="" class="icon" />
          <span>发布单位：{{ detailInfo.publishUnitName }}</span>
        </div>
      </div>
      <div class="operation d-f ai-c jc-sb">
        <div class="operation_item d-f fxd-c ai-c" @click="openApp">
          <img src="@/assets/images/detail/performance/zan.png" alt="" class="icon_operation" v-if="!detailInfo.isPraise" />
          <img src="@/assets/images/detail/performance/circle_zan.png" alt="" class="icon_operation" v-else />

          <span>{{ detailInfo.praiseNum }}</span>
        </div>
        <div class="operation_item d-f fxd-c ai-c" @click="openApp">
          <img src="@/assets/images/detail/performance/collect.png" alt="" class="icon_operation" v-if="!detailInfo.isFavorite" />
          <img src="@/assets/images/detail/culturalCollection/collect.png" alt="" class="icon_operation" v-else />

          <span>{{ detailInfo.favoriteNum }}</span>
        </div>
        <div class="operation_item d-f fxd-c ai-c" @click="openApp">
          <img src="@/assets/images/detail/performance/upload.png" alt="" class="icon_operation" />
          <span>下载</span>
        </div>
        <div class="operation_item d-f fxd-c ai-c" @click="openApp">
          <img src="@/assets/images/detail/performance/share_grey.png" alt="" class="icon_operation" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
      </div>
      <div class="content">
        <div class="title">视频简介</div>
        <div v-html="detailInfo.detail"></div>
      </div>
    </div>
    <!-- <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" /> -->
    <van-dialog
      v-model="dialogShow"
      title="请先下载客户端"
      show-cancel-button
      confirmButtonText="立即下载"
      confirmButtonColor="#A97048"
      cancelButtonText="我知道了"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
    >
      <div class="content_dialog">下载APP后查看完整内容</div>
    </van-dialog>
  </div>
</template>
<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { mapGetters } from 'vuex'
import { showVideoDetails, saveWatchLog } from '@/api/performance'
// import { submitUserFavorite, cancelFavorite, submitUserPraise, cancelPraise } from '@/api/operation'
// import { Notify, Toast, Dialog } from 'vant'

export default {
  name: 'PerformanceVideo',
  data() {
    return {
      detailInfo: {},
      showShare: false,
      id: '',
      options: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        sources: [],
        width: '100%',
        height: '100%',
        controlBar: {
          playToggle: true,
          fullscreenToggle: true,
        },
      },
      player: null, // 用来存储当前 video
      testUrl: 'http://vjs.zencdn.net/v/oceans.mp4',
      testPoster: '',
      mediaUrl: require('@/assets/images/detail/performance/video.mp4'), // 播放视频的路径
      timeParams: {
        basicId: '',
        duration: '',
      },
      isPlay: false,
      duration: '',
      isApp: false,
      dialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  methods: {
    openApp() {
      this.dialogShow = true
    },
    dialogCancel() {},
    dialogConfirm() {
      window.location.href = 'https://www.pgyer.com/ghjCEr'
    },
    async videoInit() {
      // 初始化video.js播放器
      this.$nextTick(() => {
        this.player = videojs('myVideo', this.options)

        this.player.src(this.detailInfo.videoUrl)
        // this.player.src(this.testUrl)

        this.player.on('play', () => {
          console.log('开始播放')
          this.isPlay = true
          if (this.duration) {
            this.player.currentTime(this.duration)
          }
        })
        this.player.on('ended', () => {
          console.log('播放完成')
        })
        this.player.on('pause', () => {
          this.isPlay = false
          console.log('整体时长', this.player.duration())
          console.log('播放暂停', this.player.currentTime())
          // if (this.player.currentTime() < this.player.duration()) {
          //   this.timeParams.duration = this.player.currentTime()
          //   this.saveProgress()
          // }
        })
        this.player.on('fullscreenchange', () => {
          console.log('全屏切换')
        })
        // this.player.landscapeFullscreen()
      })
    },

    async getDetail() {
      const res = await showVideoDetails(this.id)
      if (res.code == 2000) {
        this.detailInfo = res.result
        // this.detailInfo.videoUrl = this.testUrl
      }
    },
  },
  mounted() {
    console.log('this.$route=============>', this.$route.query)
    const { id } = this.$route.query
    this.id = id
    this.getDetail()
    setTimeout(() => {
      this.videoInit()
    }, 300)
  },
  beforeDestroy() {
    this.player.dispose()
  },
}
</script>
<style lang="scss">
.PerformanceVideo {
  width: 100vw;
  height: 100vh;
  background: #fff;
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #010101;
  }
  .content_dialog {
    padding: 1.6rem;
    font-size: 0.7rem;
    color: #212121;
    line-height: 1rem;
    .rules {
      font-weight: 600;
      color: #a97048;
    }
  }
  .PerformanceContent {
    width: 100%;
    // height: calc(100% - 40px - env(safe-area-inset-top));
    height: calc(100% - 57px);
    position: absolute;
    // top: calc(40px + env(safe-area-inset-top));
    top: 57px;
    left: 0;
    overflow-y: auto;
  }
  .video {
    width: 100%;
    height: 10.55rem;
    .back {
      z-index: 10;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 65px;
      // top: calc(8px + env(safe-area-inset-top));
    }
    .video-js {
      width: 100%;
      height: 10.55rem;
    }
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    // border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      // color: #47988a;
      color: #a97048;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      // background: #dff2f2;
      background: #f9eddc;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .operation {
    padding: 0 1.65rem;
    .operation_item {
      font-size: 0.6rem;
      color: #212121;
      line-height: 0.8rem;
      .icon_operation {
        width: 1.4rem;
        height: 1.4rem;
        margin-bottom: 2px;
      }
    }
  }
  .content {
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    padding: 0 0.6rem;
    .title {
      margin: 1.2rem 0 0.6rem 0;
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
    }
  }
}
</style>
